<template>
  <div>
    <div class="d-md-flex align-center justify-space-between">
      <v-dialog
          v-model="dialogWarning"
          width="500"
      >
        <v-card class="card-custom">
          <v-card-title>
            <v-row>
              <v-col cols="10" class="text-left text-h5">
               Warning
              </v-col>
              <v-col cols="2" class="text-right action">
              <span class="font-weight-bold text-h6" @click="closeModalWarning">
                 X
              </span>
              </v-col>
            </v-row>
          </v-card-title>
          <v-container fluid>
            <p class="text-center">The traffic source you selected contains notable sub-campaigns.
              If you haven’t yet, it is recommended to analyze the traffic by sub-campaigns
              and take action against the faulty ones.
            </p>
            <p class="text-center">
              If you still want to block the specified traffic, click Confirm below.
            </p>
            <p>
              {{this.user[0].role === 'QA' && 'it is appear only for QA role for debugging' }}
              {{this.user[0].role === 'QA' && JSON.stringify(this.checkTrafficPaymentsDataDebug)}}
            </p>
          </v-container>
          <v-container>

          </v-container>
          <v-card-actions>
            <v-col class="text-right">
              <v-btn
                  @click="agreeModalWarning"
                  class="reportButtonColor"
              >
                Confirm
              </v-btn>
            </v-col>

          </v-card-actions>
        </v-card>
      </v-dialog>
      <ReportTraffic
        :isModalOpened="dialogCompose"
        @closeModal="dialogCompose=false"
        @updateAffiliates="updateAffiliates"
        @report="saveBlocking"
      />
      <ValidationAlert
        :titleType="validationAlert.titleType"
        :context="validationAlert.context"
        :buttonText="validationAlert.buttonText"
        :isModalOpened="validationAlert.isModalOpened"
        @closeModal="validationAlert.isModalOpened = false"
        @submit="submitValidationForm"
      />
      <div class="d-md-flex align-center justify-space-between fill-width">
        <h1 class="mb-0 mr-3">
          Traffic Control
          <v-btn
              color="red"
              x-small
              v-show="this.user[0].can('traffic_control_manage')"
              @click="openModal"
              style="min-width: 0; min-height: 30px"
          >
            <span style="font-size: 24px">
              <v-icon color="white" medium dark> mdi-flag-outline </v-icon>
            </span>
          </v-btn>
        </h1>
       </div>

      <div class="d-md-flex align-center justify-space-between fill-width">
        <v-btn
            x-small
            style="min-width: 0; min-height: 30px"
            color="primary"
            :disabled="this.table.selectedRecords.length === 0"
            @click="exportDataToCsv"
            class="download-css"
        >
          <span style="font-size: 24px;color: #FFFFFF">
            <svg-icon type="mdi" path="M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 15L17.55 9.54L16.13 8.13L13 11.25V2H11V11.25L7.88 8.13L6.46 9.55L12 15Z" />
          </span>
        </v-btn>
      </div>

    </div>
    <v-data-table
        :headers="table.headersBlocking"
        :header-props="{ sortIcon: null, headerClass: 'white-space-no-wrap' }"
        :items="getBlocking.data"
        :server-items-length="getBlocking.count"
        :disable-sort="true"
        :loading="table.loading"
        :footer-props="{itemsPerPageOptions: table.pageOptions}"
        :page="table.currentPage"
        :items-per-page="table.perPage"
        show-select
        loading-text="Loading... Please wait"
        fixed-header
        :class="`elevation-1 fixed-height co-data-table items-size-${table.heightCounter}`"
        item-class="td_title"
        color="#7F98A5"
        @pagination="updateTablePagination"
        @input="enterSelect($event)"
    >
      <template v-slot:top>
        <DataTableTopBar @search="search" />
      </template>

      <template v-for="item of table.headersBlocking" :slot="`header.${[item.value]}`" slot-scope="{header}">
        <data-filter
            :type="table.filters[header.value]['isRange'] ? 'range' : 'items'"
            :min="table.filters[header.value].min"
            :max="table.filters[header.value].max"
            v-if="table.filters.hasOwnProperty(header.value)"
            :items="table.filters[header.value].data"
            :entity="header.value"
            :values="table.filters[header.value].selected"
            @apply="submitFilter"
        />
        <a v-if="header.sortable === undefined || header.sortable" @click="sortColumn(header.value)">
          <span class="header_title">{{header.text}}</span>
          <v-icon
              size="16"
              color="#7F98A5"
          >
            mdi-arrow-{{header.value === table.orderBy ? table.sortColumnsAsc ? 'up' : 'down' : 'up-down'}}
          </v-icon>
        </a>
        <span v-else class="header_title">{{header.text}}</span>
      </template>


      <template v-slot:item.campaignName="{ item }">
        <span>
           {{item.campaignName || '-'}}
          </span>

      </template>

      <template v-slot:item.fieldValue="{ item }">
        <span>
           {{item.fieldValue || '-'}}
          </span>
      </template>

      <template v-slot:item.campaignName="{ item }">
        <span>
           {{item.campaignName || '-'}}
          </span>
      </template>

      <template v-slot:item.context="{ item }">
        <span>
           {{item.context || '-'}}
          </span>
      </template>

      <template v-slot:item.isBlockTraffic="{ item }">
        <span>
           {{actionTaken(item) || '-'}}
          </span>

      </template>

      <template v-slot:item.countriesCode="{ item }">
        <span>
           {{countiesCodeFormat(item) || ''}}
          </span>

      </template>

      <template v-slot:item.heldPayments="{ item }">
        <span>
           {{heldPaymentsFormat(item) || '-'}}
          </span>

      </template>
      <template v-slot:item.actions="{item}">

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <button
                v-bind="attrs"
                v-on="on"
                v-show="isHaveAccessToDelete(item)"
                @click="confirmationRequired(item.id)"
                class="td_title btn btn-link"
            >
              <i class="fas fa-undo"></i>
            </button>
          </template>
          <span>Undo</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <div class="loader-wrapper" v-if="loading">
      <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>

  </div>
</template>

<script>
import MainLayout from "../../layouts/MainLayout"
import DataTableTopBar from '@/components/common/DataTableTopBar'
import ReportTraffic from './traffic/ReportTraffic'
import ValidationAlert from './traffic/ValidationAlert'
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex'
import store from '../../../store'
import {debounce} from "debounce"
import Papa from 'papaparse'
import { format } from 'd3-format'
import { mdiTrayArrowDown } from '@mdi/js'

import {getCookie} from "@/helpers";
const PERCENTAGE_SUB_CAMPAIGN = 20;
export default {
  name: 'Blocking',
  data() {
    return {
      mdiTrayArrowDown: mdiTrayArrowDown,
      detailTab: {},
      dialogCompose: false,
      dialogWarning: false,
      resolve: null,
      reject: null,
      dialog: false,
      checkTrafficPaymentsDataDebug:[],
      singleSelect: false,
      affiliateSelected:'',
      affiliates:[],
      searchTerm: "",
      selected: [],
      expanded: [],
      sheet: false,
      loading: false,
      checkedDomains: {},
      isBlockTraffic:false,
      isBlockPayments:false,
      isAffiliateBlacklisted:false,
      blockReason:'',
      affiliateInput: 0,
      validationAlert: {
        titleType: '',
        context: '',
        buttonText: '',
        isModalOpened: false,
        isSubmitted: false,
        id: null,
      },
      affiliateValidation: [
        value => !!value || 'Required.',
        value => (value && value.length >= 5) || 'Min 5 characters',
        value => Number.isInteger(Number(value)) || "The value must be an integer number"
      ],
      campaignIdInput:'',
      subCampaignInput:'',
      campaignValidation: [
        // value => (value && value !==0 && value.length >= 5) || 'Min 5 characters',
        value => Number.isInteger(Number(value)) || "The value must be an integer number"
      ],
      table: {
        search: '',
        heightCounter: 45,
        loading: false,
        searchInAffiliates: '',
        selectedRecords: [],
        awaitingSearch: false,
        currentPage: 1,
        perPage: 10,
        pageOptions: [25, 50, 100, 200, 500],
        orderBy: '',
        sortColumnsAsc: true,
        headersBlocking: [
          {text: 'Affiliate', value: 'affiliateName', align: 'left'},
          {text: 'Campaign', value: 'campaignName', align: 'left'},
          {text: 'Sub-Campaign', value: 'fieldValue', align: 'left'},
          {text: 'Action Taken', value: 'isBlockTraffic', align: 'left'},
          {text: 'Context', value: 'context', align: 'left'},
          {text: 'Blocked Countries', value: 'countriesCode', align: 'left'},
          {text: 'Held Payments', value: 'heldPayments', align: 'center'},
          {text: 'Date', value: 'dateAdded', align: 'left'},
          {text: 'User', value: 'user', align: 'left', width: '50px'},
          {text: 'Actions', value: 'actions', align: 'center', sortable: false },
        ],
        filters: {
          affiliateName: {selected: [], data: [], min: 0, max: 1, isRange: false},
          campaignName: {selected: [], data: [], min: 0, max: 1, isRange: false},
          // heldPayments: {selected: [], data: [], min: 0, max: 1, isRange: true},
          fieldValue: {selected: [], data: [], min: 0, max: 1, isRange: false},
          context: {selected: [], data: [], min: 0, max: 1, isRange: false},
        }
      }
    }
  },
  async created() {
    if (!this.user[0].can('traffic_control_read')
        && !this.user[0].can('traffic_control_manage')
    ){
      await this.$router.push('/403');
    }
  },
  async mounted() {
    await this.getGeneralData()
    await this.getFiltersData()
  },
  components: {
    MainLayout,
    DataTableTopBar,
    ReportTraffic,
    ValidationAlert
  },
  watch: {
    validationAlert: {
      deep: true,
      handler: function() {
        if(
            this.validationAlert.titleType === 'Confirmation Required' &&
            this.validationAlert.isSubmitted === true
        ) {
          this.delBlocking(this.validationAlert.id)

          this.validationAlert.isSubmitted = false
          this.validationAlert.isModalOpened = false
          this.validationAlert.id = null
        }
      }
    }
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('countries', ['getCountries']),
    ...mapGetters('blocking', [
      'getBlocking','getActiveAffiliates','getTrafficPaymentsData'
    ]),
    ...mapGetters('advertiser', ['profiles']),
  },
  methods: {
    submitValidationForm() {
      this.validationAlert.isSubmitted = true
      this.validationAlert.isModalOpened = false
    },
    formatNumber(number) {
      const formatter = format('$,.0f');
      return formatter(number);
    },
    isHaveAccessToDelete(item){
      return !item.isAffiliateBlacklisted && (this.user[0].can('traffic_control_manage'))
    },
    updateAffiliates(search, loading) {
      loading(true)
      this.debounceUpdateAffiliates(search, loading)
    },
    debounceUpdateAffiliates: debounce(async (search, loading) => {
      await store.dispatch('blocking/getActiveAffiliatesStore', {searchFilter: search })
      loading(false)
    }, 700),
    heldPaymentsFormat({heldPayments}){
      if (heldPayments){
        return this.formatNumber(heldPayments)
      }
    },
    countiesCodeFormat({countriesCode}){

      if (countriesCode) {
        const formattedString = JSON.parse(countriesCode);
        if (Array.isArray(formattedString) && formattedString.length > 0) {
          return formattedString.join(', ');
        }
      }

      return '';
    },
    actionTaken(item){
      let action = ''
      if (item.isBlockTraffic
          && !item.isBlockPayments
          && !item.isAffiliateBlacklisted
      ){
        action ='Blocked traffic'
      } else if (
          !item.isBlockTraffic
          && item.isBlockPayments
          && !item.isAffiliateBlacklisted
      ) {
        action = 'Blocked Payments'
      } else if (
          item.isBlockTraffic
          && item.isBlockPayments
          && !item.isAffiliateBlacklisted
      ) {
        action = 'Blocked traffic & Payments'
      } else if (item.isAffiliateBlacklisted){
        action = 'Blacklisted'
      }
      return action
    },
    async checkTrafficPaymentByAffiliate(data){
      await store.dispatch('blocking/getTrafficPaymentsByAffiliateStore', data)
    },
    async saveBlocking(data){
      if (!data.affiliateSelected){
        this.validationAlert.titleType = 'Missing Traffic Source'
        this.validationAlert.context = 'You must at least select an <span class="highlighted-text">Affiliate</span>'
        this.validationAlert.buttonText = 'Got It!'
        this.validationAlert.isModalOpened = true
        return
      }

      if (
          !data.isAffiliateBlacklisted
          && !data.isBlockPayments
          && !data.isBlockTraffic
      ){
        this.validationAlert.titleType = 'Missing Action'
        this.validationAlert.context = `
          You must at least select one <span class="highlighted-text">Action</span>
        `
        this.validationAlert.buttonText = 'Got It!'
        this.validationAlert.isModalOpened = true
        return
      }

      if ((data.isAffiliateBlacklisted || data.isBlockPayments) && data.blockReason ===''){
        this.validationAlert.titleType = 'Context Required'
        this.validationAlert.context = `
          Please provide <span class="highlighted-text">context</span> when <span class="highlighted-text">blocking payments</span>.
          </br> Be advised what you enter here may be shared with the affiliate
        `
        this.validationAlert.buttonText = 'Got It!'
        this.validationAlert.isModalOpened = true
        return
      }

      if (data.affiliateSelected.id
          && data.campaignIdInput
          && !data.subCampaignInput
      ){
        await this.checkTrafficPaymentByAffiliate({
          affiliateId: data.affiliateSelected.id,
          campaignId: data.campaignIdInput
        })
        const trafficPaymentsData = this.getTrafficPaymentsData

        if (trafficPaymentsData) {
          const checkTrafficPaymentsData =  trafficPaymentsData.filter(i=>(i.percentage>=PERCENTAGE_SUB_CAMPAIGN ))
          this.checkTrafficPaymentsDataDebug = [...checkTrafficPaymentsData]
          if (checkTrafficPaymentsData.length >= 2){

            const confirm = await this.openModalWarning()
            if (!confirm){
              return
            }
          }
        }

      }
      const userName  = this.user[0].email

      const resp  = await store.dispatch('blocking/addBlockingStore', {
        affiliateId: data.affiliateSelected.id,
        campaignId: data.campaignIdInput || 0,
        fieldValue: data.subCampaignInput,
        context: data.blockReason,
        user: userName,
        isBlockTraffic: data.isBlockTraffic,
        isBlockPayments: data.isBlockPayments,
        isAffiliateBlacklisted: data.isAffiliateBlacklisted,
        blockCountries: data.blockCountries
      })

      if (resp && resp.id){
        this.validationAlert.titleType = 'Success'
        this.validationAlert.context = `Your action was <span class="highlighted-text">successfully enforced</span>`
        this.validationAlert.buttonText = 'Got It!'
        this.validationAlert.isModalOpened = true

        this.dialogCompose = false
        this.affiliateSelected = ''
        this.campaignIdInput=''
        this.subCampaignInput = ''
        this.blockReason = ''
        this.isBlockTraffic = false
        this.isBlockPayments = false
        this.isAffiliateBlacklisted = false
      } else {
        if (resp.error.includes('ER_DUP_ENTRY')){
          this.validationAlert.titleType = 'Duplicate Action'
          this.validationAlert.context = `You have <span class="warning-highlight">already taken</span> this action before`
          this.validationAlert.buttonText = 'Got It!'
          this.validationAlert.isModalOpened = true
        } else {
          this.validationAlert.titleType = 'Error'
          this.validationAlert.context = `Blocking record was not saved ${resp && resp.error}`
          this.validationAlert.buttonText = 'Got It!'
          this.validationAlert.isModalOpened = true
        }
      }
    },
    confirmationRequired(id) {
      this.validationAlert.titleType = `Confirmation Required`
      this.validationAlert.context = `You are about to <span class="highlighted-text">revert an action</span>. Are you sure?`
      this.validationAlert.buttonText = 'Yes, I am!'
      this.validationAlert.isModalOpened = true
      this.validationAlert.id = id
    },
    async delBlocking(id){
      if (this.validationAlert.isSubmitted){
        const resp = await store.dispatch('blocking/delBlockingStore', {
          id,
        })
        if (resp && resp.id){
          this.validationAlert.titleType = 'Success'
          this.validationAlert.context = `Your action was <span class="highlighted-text">successfully reverted</span>.`
          this.validationAlert.buttonText = 'Got it!'
          this.validationAlert.isModalOpened = true

          this.dialogCompose = false;
        } else {
          this.validationAlert.titleType = 'Error'
          this.validationAlert.context = `Blocking record was not saved ${resp && resp.error}`
          this.validationAlert.buttonText = 'Got it!'
          this.validationAlert.isModalOpened = true
        }
      }
    },
    exportDataToCsv() {
      const selectedRecords = this.table.selectedRecords.reduce((acc, val) => acc.concat(val), []);
      const data = selectedRecords.map(item=>{
        return {
          'Affiliate': item.affiliateName,
          'Campaign': item.campaignName,
          'Sub-Campaign': item.fieldValue,
          'Action Taken': this.actionTaken(item),
          'Context': item.context,
          'Held Payments': item.heldPayments,
          'Date': item.dateAdded,
          'User': item.user,
        }
      })
      const csv = Papa.unparse(data);
      const link = document.createElement('a');
      link.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv));
      link.setAttribute('download', `blocking_data_${new Date()}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    openModal() {
      this.dialogCompose = !this.dialogCompose;
    },
    closeModal() {
      this.dialogCompose = false;
    },
    openModalWarning() {
      this.dialogWarning = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agreeModalWarning() {
      this.resolve(true)
      this.dialogWarning = false;
    },
    closeModalWarning() {
      this.resolve(false)
      this.dialogWarning = false;
    },
    updateTablePagination(params) {
      this.table.currentPage = params.page
      this.table.perPage = params.itemsPerPage

      this.getGeneralData();
    },
    enterSelect(values) {
      this.table.selectedRecords.length = 0
      this.table.selectedRecords.push(values)
      if (values.length === 0){
        this.table.selectedRecords.length = 0
      }
    },
    async getFiltersData() {
      this.getBlocking.data.forEach(value => {
        Object.keys(value).forEach(key => {
          if (this.table.filters[key] && value[key]) {
            const checkDuplicate = this.table.filters[key].data.find(i=>(i.value === value[key]))
            if (!checkDuplicate){
              this.table.filters[key].data.push({
                key: key === 'affiliateName' ? value['affiliateId'] : key === 'campaignName' ? value['campaignId']: value[key],
                value: value[key]
              })
            }
            if (this.table.filters[key]['isRange']) {
              this.table.filters[key].min = +value[key] < this.table.filters[key].min ? +value[key] : this.table.filters[key].min
              this.table.filters[key].max = +value[key] > this.table.filters[key].max ? +value[key] : this.table.filters[key].max            }
          }
        })
      })
    },
    async getFilters() {
      const filters = {};
      filters['search'] = (this.table.search.length > 0) ? this.table.search : '';
      for (const name in this.table.filters) {
        filters[name] = (this.table.filters[name].selected.length > 0)
            ? `${this.table.filters[name].selected.join(',')}`
            : null;
      }
      return filters;
    },
    async sortColumn(column) {
      this.table.sortColumnsAsc = (this.table.orderBy === column) ? !this.table.sortColumnsAsc : true;
      this.table.orderBy = column
      await this.getGeneralData()
    },
    async submitFilter(data, entity) {
      this.table.currentPage = 1
      if (data && entity) {
        this.table.filters[entity].selected = data
      }
      return await this.getGeneralData()
    },
    search(value) {
      this.table.search = value;
      this.submitFilter();
    },
    ...mapActions('alert', ['ALERT_SUCCESS', 'ALERT_ERROR', 'ALERT_INFO', 'ALERT_WARNING', 'ALERT']),
    ...mapMutations('blocking', ['addBlocking']),
    async getGeneralData() {
      this.table.loading = true;
      const filters = await this.getFilters()

      await store.dispatch('blocking/saveBlockingStore', {
        pagination: {
          limit: this.table.perPage,
          page: this.table.currentPage
        },
        filters: filters || null,
        sorting: {
          orderBy: this.table.orderBy,
          orderDirectionAsc: this.table.sortColumnsAsc
        },
      })
      await store.dispatch('blocking/getActiveAffiliatesStore')
      // this.$forceUpdate()
      this.table.loading = false
    }
  }
}
</script>

<style lang="sass">
.scrollable-expand
  overflow-y: auto
  .v-data-table__wrapper
    height: auto !important
    tr
      td
        text-align: center
        .budget-sub-row
          display: flex
          justify-content: space-between
          align-items: center
          .v-text-field
            height: auto
            .v-input__control
              background-color: #E3EEF4
              .v-input__slot
                margin: 0 !important
                min-height: auto !important
                display: flex !important
                align-items: center !important
      .spacer
        width: 100px
        padding-right: 16px
        padding-left: 16px
.warning-color
  color: red !important
.primary-color
  color: var(--v-primary-base) !important
.marginLeft
  margin-left: 50px

.budget-figure
  align-items: center
  .v-input__control
    .v-input__slot
      padding: 0 4px !important
      .v-text-field__slot
        input
          text-align: center
    .v-text-field__details
      display: none

.domain-name,
.advertiser-name,
.offers-count
  cursor: pointer
  text-decoration: none
  .domain-name:hover
    color: var(--v-primary-base) !important

.status-button
  min-width: 96px !important

.mass-budget-card
  .v-card__title
    justify-content: space-between
    .text-h5
      font-weight: 600
      font-size: 32px
      color: #3A3852
  .v-card__text
    font-size: 16px
    font-weight: 700
    color: #000000 !important
    .update-budget-title,
    .update-budget-input
      display: flex
      justify-content: center
      align-items: center
      .dollar
        font-weight: 500
        font-size: 18px
        letter-spacing: 10px
    .update-budget-domains-count
      text-align: center
      .primary-color
        font-weight: 700
  .v-card__actions
    justify-content: end
    .apply-button
      background-color: #ACC3CF !important
      min-width: 150px !important

.trafficColorDisabled
  .v-label,
  .v-icon
    color: #e9e4db !important

.trafficColor
  .v-label,
  .v-icon
    color: rgb(0 0 0 / 60%) !important

.trafficColorDisabledInput
  .v-input__slot
    background-color: #E5E5E5 !important
    font-weight: bold

.labelColorDisabled
  color: #E5E5E5


.labelColorEnabled
  color: rgb(0 0 0 / 60%)
  font-weight: bold

.trafficColorInput,
.contextInput
  .v-input__slot
    background-color: #E3EEF4 !important

.separatorVertical
  margin-top: 20px !important

.separatorHorizontal
  margin-right: 40px !important

.separatorHorizontalAction
  margin-right: 40px !important

.tooltipColor
  color: var(--v-primary-base) !important

.reportButtonColor
  background-color: #358D83 !important

.v-tooltip__content
.v-tooltip__content--fixed
  max-width: 200px !important
  width: 200px !important

.download-css
  svg
    fill: #FFFFFF

</style>
